import React, { useRef } from 'react';
import { type UserAvatarModel } from '../../type/user';

const FALLBACK = '/src/assets/no-user-logo.png'; // public/ folder, not src/assets/

const UserAvatar: React.FC<UserAvatarModel> = ({ avatar, username, classname }) => {
  const errorFired = useRef(false);

  const getImageSrc = (): string => {
    if (!avatar) return FALLBACK;
    if (avatar.startsWith('data:')) return avatar;
    if (/^https?:\/\//i.test(avatar)) return avatar;
    return FALLBACK;
  };

  return (
    <img
      src={getImageSrc()}
      alt={username || 'User avatar'}
      title={username}
      className={classname}
      onError={(e) => {
        if (errorFired.current) return; // prevent infinite loop
        errorFired.current = true;
        (e.currentTarget as HTMLImageElement).src = FALLBACK;
      }}
    />
  );
};

export default UserAvatar;